import { useEffect, useState } from 'react';

import { BiQuestionMark } from 'react-icons/bi';

export const IconRenderer = ({ iconPack, iconName }: { iconPack: string; iconName: string }) => {
    const [IconComponent, setIconComponent] = useState<React.ComponentType | null>(null);

    useEffect(() => {
        import(`react-icons/${iconPack}/index.esm.js`).then(module => {
            setIconComponent(() => module[iconName]);
        });
    }, [iconPack, iconName]);

    return IconComponent ? <IconComponent /> : <BiQuestionMark />;
};
